var Icon = {
  defaultProps: {
    size: "md"
  },
  sizes: {
    xl: {
      boxSize: "48px"
    },
    lg: {
      boxSize: "40px"
    },
    md: {
      boxSize: "32px"
    },
    sm: {
      boxSize: "24px"
    },
    xs: {
      boxSize: "16px"
    }
  }
};
export var IconSize = {
  xl: "xl",
  lg: "lg",
  md: "md",
  sm: "sm",
  xs: "xs"
};
export default Icon;